import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckboxRoundSelectAllActiveIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <circle cx="12" cy="12" r="12" fill="#2196F3" />
            <path
                d="M16.478 7.83496L11.4683 12.8447M8.12848 16.1845L4.33325 12.3892"
                stroke="white"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 8.01715L11.6505 16.3667L7.85522 12.5714"
                stroke="white"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
